import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Loader2, MessagesSquare } from "lucide-react";
import { http } from "@/lib/api";

const mon = () => { const d = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Bucharest" })); d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); return d.toLocaleDateString("sv-SE"); };
const shift = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString("sv-SE"); };
const fmt = (iso, o) => new Date(`${iso}T12:00:00`).toLocaleDateString("ro-RO", o);

export default function BFRouteNotesAdmin() {
  const [start, setStart] = useState(mon);
  const [agent, setAgent] = useState("");
  const [onlyRoute, setOnlyRoute] = useState(true);
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    http.get("/bf/admin/route-notes", { params: { start, agent_slug: agent, only_route: onlyRoute } }).then((r) => setD(r.data)).catch(() => setD({ agents: [], notes: [], error: true }));
  }, [start, agent, onlyRoute]);
  const days = d ? [...new Set(d.notes.map((x) => x.date))] : [];
  return (
    <section className="invite-box bf-rna" data-testid="bf-route-notes-admin">
      <h3><MessagesSquare size={18} /> Observațiile agenților</h3>
      <p className="st-hint">Ce au notat agenții după fiecare vizită. Apasă pe salon ca să deschizi fișa.</p>
      <div className="bf-rna-filters">
        <div className="bf-plan-nav">
          <button type="button" className="st-btn st-btn--ghost" onClick={() => setStart(shift(start, -7))} data-testid="bf-rna-prev"><ChevronLeft size={16} /></button>
          <b data-testid="bf-rna-week">{fmt(start, { day: "numeric", month: "short" })} – {fmt(shift(start, 6), { day: "numeric", month: "short", year: "numeric" })}</b>
          <button type="button" className="st-btn st-btn--ghost" onClick={() => setStart(shift(start, 7))} data-testid="bf-rna-next"><ChevronRight size={16} /></button>
        </div>
        <select value={agent} onChange={(e) => setAgent(e.target.value)} data-testid="bf-rna-agent">
          <option value="">Toți agenții</option>
          {(d?.agents || []).map((a) => <option key={a.slug} value={a.slug}>{a.name}</option>)}
        </select>
        <label className="bf-rna-toggle"><input type="checkbox" checked={!onlyRoute} onChange={(e) => setOnlyRoute(!e.target.checked)} data-testid="bf-rna-all" /> Include și vizitele notate direct în fișă</label>
      </div>
      {!d ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p>
        : d.error ? <p className="st-hint" data-testid="bf-rna-error">Nu am putut încărca observațiile.</p>
        : !d.notes.length ? <p className="st-hint" data-testid="bf-rna-empty">Nicio observație în această săptămână.</p> : (
          <div className="bf-rna-feed" data-testid="bf-rna-feed">
            <p className="st-hint" data-testid="bf-rna-count">{d.notes.length} {d.notes.length === 1 ? "observație" : "observații"}</p>
            {days.map((day) => (
              <div key={day} className="bf-rna-day">
                <h4>{fmt(day, { weekday: "long", day: "numeric", month: "long" })}</h4>
                <ul>
                  {d.notes.filter((x) => x.date === day).map((x, i) => (
                    <li key={x.id || i} data-testid={`bf-rna-note-${x.id}`}>
                      <div className="bf-rna-top">
                        <Link to={`/client/${x.lead}`} data-testid={`bf-rna-link-${x.id}`}>{x.salon || "Salon"}</Link>
                        <span>{[x.city, x.agent_name].filter(Boolean).join(" · ")}</span>
                        {x.via === "ruta" ? <em>din rută</em> : <em className="is-card">din fișă</em>}
                      </div>
                      <p>{x.note}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
    </section>
  );
}
